import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import {
  RelationshipWithHierarchyData,
  getAllInheritedRelationships,
} from 'src/containers/ProjectDiagram/utils/getAllInheritedRelationships';
import { getClassHierarchy } from 'src/containers/ProjectDiagram/utils/getClassHierarchy';

export const getInheritedRelationshipsByClass = (
  model: Model | ModelSnapshot,
  classIris?: string[]
) => {
  const classIrisForHierarchy = model.nodeDataArray.reduce<Set<string>>(
    (acc, nodeData) => {
      if (isModelConceptClass(nodeData)) {
        acc.add(nodeData.value);
      }
      return acc;
    },
    new Set()
  );
  const { labelsByIri } = model.modelData;
  const { linkDataArray } = model;
  const hierarchyByIri = getClassHierarchy(
    model.linkDataArray,
    classIrisForHierarchy
  );
  const inheritedRelationshipsByClass = Array.from(
    classIris || classIrisForHierarchy
  ).reduce<Record<string, Record<string, RelationshipWithHierarchyData>>>(
    (agg, classIri) => ({
      ...agg,
      [classIri]: getAllInheritedRelationships({
        classIri,
        hierarchyByIri,
        labelsByIri,
        linkDataArray,
      }),
    }),
    {}
  );

  return inheritedRelationshipsByClass;
};
